import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../Styles/Profile.css"; // create a css file for styling

const Profile = () => {
  const location = useLocation();
  const { agentId } = location.state || {};
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    if (agentId) {
      fetchProfile(agentId);
    }
  }, [agentId]);

  const fetchProfile = async (id) => {
    try {
      const response = await fetch(
        `https://b2bdubaibackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${id}`,
        { method: "POST", headers: { "Content-Type": "application/json" } }
      );
      if (response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch profile");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  if (!profileData) return <div>Loading Profile...</div>;

  return (
    <div className="profile-container">
      <h2>Profile Details</h2>
      <form className="profile-form">
        <div class="form-row-3">
        <div className="form-row">
          <label>Company Name:</label>
          <input type="text" value={profileData.companyName || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Full Name:</label>
          <input type="text" value={profileData.fullName || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Phone Number:</label>
          <input type="text" value={profileData.phoneNumber || "-"} readOnly />
        </div>
        </div>
          <div class="form-row-3">
             <div className="form-row">
          <label>Whatsapp Number:</label>
          <input type="text" value={profileData.whatsappNumber || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Email Address:</label>
          <input type="text" value={profileData.emailAddress || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Referred By:</label>
          <input type="text" value={profileData.referredBy || "-"} readOnly />
        </div>
          </div>
        <div class="form-row-3">
             <div className="form-row">
          <label>Country:</label>
          <input type="text" value={profileData.country || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>State:</label>
          <input type="text" value={profileData.state || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>City:</label>
          <input type="text" value={profileData.city || "-"} readOnly />
        </div>
        </div>
        <div class="form-row-3">
             <div className="form-row">
          <label>Address:</label>
          <input type="text" value={profileData.address || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Pincode:</label>
          <input type="text" value={profileData.pincode || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Locality:</label>
          <input type="text" value={profileData.locality || "-"} readOnly />
        </div>
        </div>
        <div class="form-row-3">
             <div className="form-row">
          <label>Nearest Airport:</label>
          <input type="text" value={profileData.nearestAirport || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Primary Business:</label>
          <input type="text" value={profileData.primaryBusiness || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Monthly Business:</label>
          <input type="text" value={profileData.monthlyBusiness || "-"} readOnly />
        </div>
        </div>
        <div class="form-row-3">
             <div className="form-row">
          <label>Secondary Business:</label>
          <input type="text" value={profileData.secondaryBusiness || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Secondary Monthly Business:</label>
          <input type="text" value={profileData.secondaryMonthlyBusiness || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Company Trade License:</label>
          {profileData.companyTradeLicense ? (
            <a
              href={profileData.companyTradeLicense}
              target="_blank"
              rel="noopener noreferrer"
              className="doc-link"
            >
              View Document
            </a>
          ) : (
            <span>-</span>
          )}
        </div>
        </div>
       <div class="form-row-3">
          <div className="form-row">
          <label>VAT Registration Number:</label>
          <input type="text" value={profileData.vatRegistrationNumber || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Online OTAs:</label>
          <input type="text" value={profileData.onlineOTAs || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Series OTAs:</label>
          <input type="text" value={profileData.seriesOTAs || "-"} readOnly />
        </div>
        <div className="form-row">
          <label>Wallet Balance:</label>
          <input type="text" value={profileData.wallet || "0"} readOnly />
        </div>
       </div>
      
      </form>
    </div>
  );
};

export default Profile;
